import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown, faFileLines, faEye } from '@fortawesome/free-solid-svg-icons';
import Button from '../../../components/Buttons/button';
import Api from '../../../services/api.service';

export default function GroupDownloadQuotations({ group, quotations }) {
    const { t } = useTranslation();

    async function visualize(q) { await Api.visualizeQuotation(q); }
    async function download(q) { await Api.downloadQuotation(q); }

    return (
        <div>
            <h2 className='font-bold text-lg text-secondary'>
                {t('pageQuotation.step1.titleYourQuotation')}
            </h2>

            <div className="mt-4 grid gap-3">
                {quotations.map((q) => (
                    <div key={q._id} className="flex flex-col md:flex-row md:justify-between items-start md:items-center border rounded-xl p-3">
                        <div className='flex items-center gap-3'>
                            <FontAwesomeIcon icon={faFileLines} className='h-6 text-main' />
                            <span>
                                {t('pageQuotation.step1.nameQuotation')} {q.mainInfos?.quotationNumber}
                                {q?.mainInfos?.title ? ` — ${q.mainInfos.title}` : ''}
                            </span>
                        </div>

                        <div className='flex items-center gap-3 mt-3 md:mt-0'>
                            <Button
                                text={t('pageQuotation.step1.buttonLabelVisualizeQuotation')}
                                onClick={() => visualize(q)}
                                className='w-full md:w-fit'
                                leftIcon={<FontAwesomeIcon icon={faEye} />}
                            />
                            <FontAwesomeIcon
                                icon={faCloudArrowDown}
                                className='h-6 text-main cursor-pointer'
                                onClick={() => download(q)}
                                title={t('quotation.step1.download')}
                            />
                        </div>
                    </div>
                ))}

                {!quotations.length && (
                    <div className="italic text-description">{t('pageQuotation.step1.noItems') || 'Aucun devis dans ce groupe.'}</div>
                )}
            </div>

            {/* Group total */}
            <div className="mt-4 text-right">
                <span className="font-semibold">
                    {t('pageQuotation.step1.total') || 'Total'} :&nbsp;
                    {Number(group?.amountTotal || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}&nbsp;€
                </span>
            </div>
        </div>
    );
}